import React, { useEffect } from 'react';
import { HashRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import Projects from './pages/Projects';
import Services from './pages/Services';
import Blogs from './pages/Blogs';
import BlogDetail from './pages/BlogDetail';
import './App.css';

function AppContent() {
  const location = useLocation();

  useEffect(() => {
    const isSmallScreen = window.matchMedia('(max-width: 768px)').matches;

    const selectors = [
      '.profile-hero-left',
      '.profile-hero-right',
      '.page-hero-content',
      '.ab-hero-box',
      '.ab-story-card',
      '.service-pro-card',
      '.project-pro-card',
      '.bl-card',
      '.blog-detail-header',
      '.insight-card',
      '.home-service-card',
      '.home-edu-card',
      '.home-skill-card',
      '.contact-pro-form-wrap',
      '.contact-pro-info',
    ].join(',');

    const elements = Array.from(document.querySelectorAll(selectors));

    if (!elements.length) return undefined;

    if (isSmallScreen) {
      elements.forEach((el) => {
        el.classList.remove('reveal-init');
        el.classList.remove('reveal-in');
        el.style.removeProperty('--reveal-delay');
      });
      return undefined;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('reveal-in');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.08, rootMargin: '0px 0px -4% 0px' }
    );

    elements.forEach((el, index) => {
      el.classList.remove('reveal-in');
      el.classList.add('reveal-init');
      el.style.setProperty('--reveal-delay', `${Math.min((index % 4) * 16, 48)}ms`);
      observer.observe(el);
    });

    return () => observer.disconnect();
  }, [location.pathname]);

  return (
    <div className="App">
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/blog/:id" element={<BlogDetail />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
